import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function getItem(ids, itemShape, shapeName, requestServerVersion, options) {
    var jsonRequestHeader = getJsonRequestHeader();
    if (requestServerVersion) {
        jsonRequestHeader.RequestServerVersion = requestServerVersion;
    }
    var serviceItemIds = ids.map(function (id) {
        return itemId({ Id: id });
    });
    return getItemOperation({
        Header: jsonRequestHeader,
        Body: getItemRequest({
            ItemShape: itemShape,
            ItemIds: serviceItemIds,
            ShapeName: shapeName,
        }),
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items;
    });
}
//# sourceMappingURL=getItem.js.map